<script>
export default {
  name: "strock-reject-icon",
  props: ["strokeColor"]
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="9"
    viewBox="0 0 10 9"
    fill="none"
  >
    <path
      d="M8 1.5L2 7.5M2 1.5L8 7.5L2 1.5Z"
      :stroke="strokeColor ? strokeColor : '#EC484A'"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
